import { render, staticRenderFns } from "./WhatsappTemplates.vue?vue&type=template&id=29ed38a6&"
import script from "./WhatsappTemplates.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports